(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturalia-brosse-visual"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-nbv-toggle]');if(!button)return;const carousel=button.closest('[data-nbv-carousel]');const paused=carousel.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.play:button.dataset.pause;});

function updateBrossePack(input){
 const main=input.closest('product-info')||input.closest('.shopify-section');
 if(!main)return;
 main.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(id){id.value=input.value;id.dispatchEvent(new Event('change',{bubbles:true}));});
 const available=input.dataset.available==='true';
 main.querySelectorAll('button[name="add"]').forEach(function(button){button.disabled=!available;button.querySelector('span').textContent=available?(document.documentElement.lang==='en'?'Add to cart':'Ajouter au panier'):(document.documentElement.lang==='en'?'Sold out':'Épuisé');});
 const root=input.closest('.nb-offers');const pack=Number(input.dataset.pack);
 root.querySelector('[data-gift-heading]').textContent=pack>1?(document.documentElement.lang==='en'?'YOUR FREE GIFTS':'VOS CADEAUX OFFERTS'):(document.documentElement.lang==='en'?'LOCKED GIFTS':'CADEAUX VERROUILLÉS');
 root.querySelectorAll('[data-gift-min]').forEach(function(gift){const locked=pack<Number(gift.dataset.giftMin);gift.classList.toggle('is-locked',locked);gift.querySelector('[data-gift-state]').textContent=locked?(Number(gift.dataset.giftMin)===3?(document.documentElement.lang==='en'?'Locked — offer 3':'Verrouillé — offre 3'):(document.documentElement.lang==='en'?'Locked — offer 2':'Verrouillé — offre 2')):(document.documentElement.lang==='en'?'Unlocked — free':'Déverrouillé — offert');});
 const url=new URL(window.location.href);url.searchParams.set('variant',input.value);window.history.replaceState({},'',url);
}
document.addEventListener('change',function(event){if(event.target.matches('.nb-offer input'))updateBrossePack(event.target);});
function initBrossePacks(){document.querySelectorAll('.nb-offer input:checked').forEach(updateBrossePack);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initBrossePacks);else initBrossePacks();
document.addEventListener('shopify:section:load',initBrossePacks);

document.addEventListener('click',function(event){const button=event.target.closest('[data-nbv-more]');if(!button)return;button.closest('.nbv-reviews').querySelector('.nbv-review-grid').classList.add('is-expanded');button.remove();});

function initNaturaliaReviewDialog(){document.querySelectorAll('.nbv-review-grid article').forEach(function(article){article.setAttribute('role','button');article.tabIndex=0;article.setAttribute('aria-haspopup','dialog');article.setAttribute('aria-label',(document.documentElement.lang==='en'?'Read the review by ':'Lire l’avis de ')+article.querySelector('.nbv-review-meta strong').textContent);});}
function openNaturaliaReview(article){let dialog=document.querySelector('.nbv-review-dialog');if(!dialog){dialog=document.createElement('dialog');dialog.className='nbv-review-dialog';dialog.setAttribute('aria-label',(document.documentElement.lang==='en'?"Detailed customer review":"Avis client détaillé"));document.body.append(dialog);dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});dialog.addEventListener('close',function(){document.documentElement.style.overflow='';});}dialog.replaceChildren();const head=document.createElement('div');head.className='nbv-dialog-head';const avatar=document.createElement('span');avatar.className='nbv-dialog-avatar';avatar.setAttribute('aria-hidden','true');const name=article.querySelector('.nbv-review-meta strong').textContent;avatar.textContent=name.split(/\s+/).map(function(word){return word[0];}).join('').slice(0,2);const info=document.createElement('div');const author=document.createElement('p');author.className='nbv-dialog-author';author.textContent=name;const date=document.createElement('div');date.className='nbv-dialog-date';date.textContent=article.querySelector('.nbv-review-meta span').textContent;const rating=document.createElement('div');rating.className='nbv-dialog-rating';const stars=document.createElement('span');stars.className='nbv-dialog-stars';stars.textContent='★★★★★';rating.append(stars,document.createTextNode((document.documentElement.lang==='en'?"5 stars":"5 étoiles")));info.append(author,date,rating);const close=document.createElement('button');close.type='button';close.className='nbv-dialog-close';close.setAttribute('aria-label',(document.documentElement.lang==='en'?"Close review":"Fermer l’avis"));close.textContent='×';close.addEventListener('click',function(){dialog.close();});head.append(avatar,info,close);const body=document.createElement('div');body.className='nbv-dialog-body';body.append(article.querySelector('h3').cloneNode(true),article.querySelector('.nbv-review-text').cloneNode(true));const photo=article.querySelector('img');if(photo)body.append(photo.cloneNode(true));const footer=document.createElement('div');footer.className='nbv-dialog-foot';const prompt=document.createElement('span');prompt.textContent=(document.documentElement.lang==='en'?"Was this review helpful?":"Cet avis vous a-t-il été utile ?");footer.append(prompt);[(document.documentElement.lang==='en'?"Yes":"Oui"),(document.documentElement.lang==='en'?"No":"Non")].forEach(function(label){const vote=document.createElement('button');vote.type='button';vote.className='nbv-dialog-vote';vote.textContent=label;vote.setAttribute('aria-pressed','false');vote.addEventListener('click',function(){footer.querySelectorAll('button').forEach(function(button){button.setAttribute('aria-pressed',String(button===vote));});prompt.textContent=(document.documentElement.lang==='en'?"Thank you for your feedback.":"Merci pour votre retour.");});footer.append(vote);});dialog.append(head,body,footer);document.documentElement.style.overflow='hidden';dialog.showModal();}
document.addEventListener('click',function(event){const article=event.target.closest('.nbv-review-grid article');if(article)openNaturaliaReview(article);});document.addEventListener('keydown',function(event){if((event.key==='Enter'||event.key===' ')&&event.target.matches('.nbv-review-grid article')){event.preventDefault();openNaturaliaReview(event.target);}});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initNaturaliaReviewDialog);else initNaturaliaReviewDialog();document.addEventListener('shopify:section:load',initNaturaliaReviewDialog);

  } catch(e) { console.error(e); }
})();
})();
